import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from '@/components/Icons/ChevronRight';
import { PlusSign } from '@/components/Icons/PlusSign';

interface Props {
  label: string;
  onAdd: () => void;
}

export const AddContactRow: React.FC<Props> = ({ label, onAdd }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onAdd}
      className="mx-4 flex h-12 cursor-pointer items-center gap-3 rounded-xl bg-info-surface px-4 text-left contrast:border contrast:border-border"
    >
      <span className="min-w-0 flex-1 text-subhead-14 text-foreground">
        {label}
      </span>
      <span className="flex h-6 items-center gap-2 text-body-13 font-semibold text-primary md:text-subhead-14 md:font-medium">
        <PlusSign strokeWidth="1.8" className="size-3.5 shrink-0" />
        {t('global.add')}
      </span>
      <ChevronRight
        strokeWidth="1.8"
        className="size-3.5 shrink-0 text-muted-foreground md:hidden"
      />
    </button>
  );
};
